import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import { hexify } from '../../utils';

const AnnouncementTileContentAndCta = ({
  action,
  secondary_action: secondaryAction,
  trackClick,
  color_dict: colorDict,
  title,
  content,
  action_text: actionText,
  secondary_action_text: secondaryActionText,
}) => (
  <div>
    <div
      className="AnnouncementTile__tile-text--content"
      style={{ color: hexify(colorDict.content_text) }}
    >
      {content}
    </div>
    <div className="AnnouncementTile__tile-text__button-group">
      <Button
        className="AnnouncementTile__tile-text--cta-primary"
        variant="primary"
        sm
        href={action?.data?.url}
        onClick={() => trackClick(title)}
        colors={{
          background: `${colorDict.button}`,
          font: `${colorDict.button_text}`,
        }}
        target="_blank"
      >
        {actionText}
      </Button>
      {secondaryActionText
        && (
          <Button
            className="AnnouncementTile__tile-text--cta-secondary"
            variant="secondary"
            sm
            href={secondaryAction?.data?.url}
            onClick={() => trackClick(title)}
            colors={{
              background: `${colorDict.secondary_button}`,
              font: `${colorDict.secondary_button_text}`,
            }}
            target="_blank"
          >
            {secondaryActionText}
          </Button>
        )}
    </div>
  </div>
);

AnnouncementTileContentAndCta.propTypes = {
  action: PropTypes.shape({
    data: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  action_text: PropTypes.string,
  secondary_action: PropTypes.shape({
    data: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  secondary_action_text: PropTypes.string,
  color_dict: PropTypes.shape({
    button: PropTypes.string,
    button_text: PropTypes.string,
    content_text: PropTypes.string,
    secondary_button: PropTypes.string,
    secondary_button_text: PropTypes.string,
  }),
  content: PropTypes.string,
  title: PropTypes.string,
  trackClick: PropTypes.func,
};

AnnouncementTileContentAndCta.defaultProps = {
  action: {},
  action_text: '',
  secondary_action: {},
  secondary_action_text: '',
  color_dict: {},
  content: '',
  title: '',
  trackClick: () => { },
};

export default AnnouncementTileContentAndCta;
